/**
 * Non-Site Observations summary page — backlink placeholder + DataTables.
 * No chart on this page (Observations has no single categorical field
 * comparable to Activity 3's survival outcome).
 */
const init_nonsite_summary_table = require('../helpers/_nonsite-summary-table');

module.exports = function init_nonsite_observations($) {

  const slugs = window.mlmp_settings || {};

  init_nonsite_summary_table($, {
    back_link: slugs.nonsite_observations_back_link,
    table_settings: slugs.nonsite_observations || {},
  });

};
